@for (data of dataList; track data) {
  <section>
    <div class="link__list">
      @if (data.icon) {
        <icon
          [name]="data.icon"
          [config]="{
            size: 'small',
            type: 'link',
          }"
        >
        </icon>
      }
      @if (data.route) {
        <a
          class="t-data t-bold t-link"
          [routerLink]="[data.route]"
          (click)="linkClicked(data)"
        >
          {{ data.label }}
        </a>
      }
      @if (data.href) {
        <a
          class="t-data t-bold t-link"
          href="{{ data.href }}"
          (click)="linkClicked(data, 'link')"
          [attr.target]="data.target ? data.target : '_blank'"
        >
          {{ data.label }}
        </a>
      }
    </div>
  </section>
}
